import { render, staticRenderFns } from "./FactFind.vue?vue&type=template&id=5c895496&scoped=true&"
import script from "./FactFind.vue?vue&type=script&lang=js&"
export * from "./FactFind.vue?vue&type=script&lang=js&"
import style0 from "./FactFind.vue?vue&type=style&index=0&id=5c895496&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../RetirementPlanner.Demo/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c895496",
  null
  
)

export default component.exports